import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { env } from 'process';
import { AuthApiService } from 'src/app/services/auth-api.service';
import { SettingsService } from 'src/app/services/settings.service';
import { SsoService } from 'src/app/services/sso.service';
import { AuthResponse } from 'src/app/shared/models/users/auth-response';
import { SignIn } from 'src/app/shared/models/users/sign-in';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { NgForm } from '@angular/forms';
import { UserToken } from 'src/app/shared/models/users/user-token';
import { getEmailRegExpression } from 'src/app/shared/utils/email-reg';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
   @Output() loginSuccessful = new EventEmitter<boolean>(); 
   
  reCaptchaKey = env.reCaptchaKey;
  busy: boolean = false;  
  otpBusy: boolean = false;
  errorMsg: string = "test";//"Incorrect Username or Password";
  showError: boolean = false;
  showPasswordField:boolean = true;
  showOtpField: boolean = true; 
  showOtpVerification: boolean = false;
  emailRegExpression = getEmailRegExpression();  
  
  signIn: SignIn = new SignIn();
  userToken: UserToken = {
      userId: 0,
      otp: null,
      redirectUrl: null,
      token: null,
      tokenExpiry: null
  };

  constructor(
    private router: Router,
    private authApi: AuthApiService,
    private ssoService: SsoService,
    public settingsService: SettingsService,
    private recaptchaV3Service: ReCaptchaV3Service,
    private activeRoute: ActivatedRoute
  ) { }

  
  ngOnInit(): void {      
    const currentUrl = this.router.url;    
    if(currentUrl.includes("?returnUrl")){
      const returnUrl = this.activeRoute.snapshot.queryParamMap.get('returnUrl');
      if (returnUrl) {
        this.userToken.redirectUrl = returnUrl;
        localStorage.setItem('returnUrl', returnUrl);
      }
    }    
  }  

  isEmptyString = (data: string): boolean => typeof data === "string" && data.trim().length == 0;

  public async SignIn(signInForm: NgForm) {
    if (signInForm.invalid) {
      signInForm.form.markAllAsTouched();
      return;
    }
    this.busy = true;
    this.errorMsg = "";
    this.recaptchaV3Service.execute("Login").subscribe(token => {
      this.authApi.login(this.signIn).toPromise()
        .then(
          (uId: number) => {
            this.showOtpVerification = true;
            this.userToken.userId = uId;
            this.busy = false;
          },
          (error) => {
            this.showError = true;
            this.errorMsg = this.interpretError(error);
            this.busy = false;
          }
        )
    });
  }

   public async VerifyOtp(otpForm: NgForm) {
    if (otpForm.invalid) {
      otpForm.form.markAllAsTouched();
      return;
    }
    this.errorMsg = '';
    this.showError = false;
    this.otpBusy = true;
    this.authApi.validateOtp(this.userToken).subscribe({
      next: (authResponse: AuthResponse) => {
        this.storeTokenInBrowser(authResponse);
        this.settingsService.userId = this.userToken.userId;

        if (this.userToken.redirectUrl) {
          this.handleSsoRedirect();
          return;
        }

        this.settingsService.GetUserDetails().then(() => {
          this.otpBusy = false;
          this.router.navigate(['dashboard']);
        });
      },
      error: (error) => {
        this.showError = true;
        this.errorMsg = this.interpretError(error);
        this.otpBusy = false;
      },
    });
  }

  private handleSsoRedirect(): void {
    this.ssoService.RecheckUser(this.userToken).subscribe({
      next: (result) => {
        if (result.ssoRedirectUrl?.startsWith('http')) {
          const url = new URL(result.ssoRedirectUrl);
          url.searchParams.set('authToken', result.ssoAuthToken);
          window.location.href = url.toString();
          return;
        }

        this.settingsService.GetUserDetails().then(() => {
          this.otpBusy = false;
          this.router.navigateByUrl(this.userToken.redirectUrl || 'dashboard');
        });
      },
      error: () => {
        this.showError = true;
        this.errorMsg = 'Could not complete sign-in redirect.';
        this.otpBusy = false;
      },
    });
  }

  storeTokenInBrowser(authResponse: AuthResponse): void {
    localStorage.setItem('token', authResponse.accessToken);
    localStorage.setItem('tokenExpires', String(authResponse.expiresAt));
    localStorage.setItem('userId', this.userToken.userId.toString());
  }

  interpretError(error: any) {

    if (typeof error?.error?.ErrorDetail === "string" && error.error.ErrorDetail.length > 0) {      
      return error.error.ErrorDetail;
    }

    if (typeof error?.error?.errorDetail === "string" && error.error.errorDetail.length > 0) {
      return error.error.errorDetail;
    }

    if (typeof error?.message === "string" && error.message.length > 0) {      
      if (error.message.includes("Http failure response")) {

        if (typeof error?.statusText === "string" && error.statusText.length > 0) {
          if (error.statusText.includes("Unknown Error")) {
            return "Couldn't connect to the Trakly Platform";
          }

          return error.statusText;
        }

        return "Oops, something broke and said: \"" + error.statusText + "\" (status code " + error.status + ")";
      }
    }

    return "Unknown Error";
  }

  showPassword() {
    this.showPasswordField = !this.showPasswordField;
  }

}
